import { API } from '../../providers/ApiInterceptorProvider';
import { ExistingFirmResponse, FCAOrganisationDetails, LinkBrokerToFirmResult } from './firm.types';

const trimFca = (fca: string) => fca.trim();

export const firmApi = {
  getFirmByFca: async (fca: string): Promise<ExistingFirmResponse | null> => {
    const { data } = await API.get<ExistingFirmResponse[]>(`/monolith/referrers/firms`, {
      params: { fca: trimFca(fca) },
    });
    return data.at(0) ?? null;
  },

  getFirmDetails: async (fca: string): Promise<FCAOrganisationDetails> => {
    const res = await API.get<FCAOrganisationDetails>(`/monolith/referrers/${trimFca(fca)}/firm-details`);
    return res.data;
  },

  linkBrokerToExistingFirm: async (firmId: string): Promise<LinkBrokerToFirmResult> => {
    const { data } = await API.post<LinkBrokerToFirmResult>(`/monolith/referrers/firms/${firmId}/brokers`);
    return data;
  },

  linkFirmToMortgageClub: async (firmId: string, clubId: string) => {
    await API.patch(`/monolith/referrers/firms/${firmId}/linkToClub/${clubId}`);
  },
  linkFirmToNetwork: async (firmId: string, networkId: string) => {
    await API.patch(`/monolith/referrers/firms/${firmId}/linkToNetwork/${networkId}`);
  },
};
